<template>
	<div class="form-inputs">
		<FormLabelTooltip
			:required="required"
			:name="`select-${name}`"
			:label="label"
		/>
		<select
			class="b360-form-input"
			:class="selectStateStyles"
			v-model="selectedOption"
			@change="
				(event) => {
					$emit('input', { fieldName: name, value: event.target.value });
				}
			"
			:id="`select-${name}`"
			:required="required"
			:disabled="disabled"
		>
			<option
				v-for="(option, index) in americanStates"
				:value="option"
				:key="index"
			>
				{{ option }}
			</option>
		</select>
	</div>
</template>

<script>
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';

export default {
	name: 'StateDropdown',
	components: {
		FormLabelTooltip,
	},
	props: {
		name: String,
		label: String,
		placeholder: String,
		required: Boolean,
		value: null,
		disabled: Boolean,
		error: null,
	},
	data() {
		return {
			selectedOption: null,
			americanStates: [
				'',
				'AL',
				'AK',
				'AZ',
				'AR',
				'CA',
				'CO',
				'CT',
				'DC',
				'DE',
				'FL',
				'GA',
				'HI',
				'ID',
				'IL',
				'IN',
				'IA',
				'KS',
				'KY',
				'LA',
				'MA',
				'ME',
				'MD',
				'MI',
				'MN',
				'MS',
				'MO',
				'MT',
				'NE',
				'NV',
				'NH',
				'NJ',
				'NM',
				'NY',
				'NC',
				'ND',
				'OH',
				'OK',
				'OR',
				'PA',
				'RI',
				'SC',
				'SD',
				'TN',
				'TX',
				'UT',
				'VA',
				'VT',
				'WA',
				'WI',
				'WV',
				'WY',
			],
		};
	},
	mounted() {
		this.selectedOption = this.value;
	},
	watch: {
		value(newValue) {
			this.selectedOption = newValue;
		},
	},
	computed: {
		selectStateStyles() {
			return {
				'b360-form-input--disabled': this.disabled,
				error: this.error,
			};
		},
	},
};
</script>

<style lang="scss" scoped>
select.b360-form-input {
	height: 44px;
	padding: 0.6rem 0.75rem;

	&--disabled {
		color: #555;
		background-color: #f5f5f5;
	}
}

.error {
	border: 1px solid $error;
}
</style>
